import { render, staticRenderFns } from "./LicenseTile.vue?vue&type=template&id=394f53aa"
import script from "./LicenseTile.vue?vue&type=script&lang=js"
export * from "./LicenseTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports